import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import { BrowserRouter, Switch, Route } from "react-router-dom";

import Payment from "./components/PaymentPage";
import Schedule from "./components/Schedule";
import UpdateAvailability from "./components/UpdateAvailability";

import "./App.css";
import { Suspense } from "react";
import { SET_USER } from "./store/user/types";
import { useDispatch, useSelector } from "react-redux";
import Home from "./pages/home";

import { db } from "./firebase/firebase";
import ProfileInterview from "./components/ProfileInterview";

function App() {
  const dispatch = useDispatch();
  const isAuth = localStorage.getItem("isAuth");
  const userId = localStorage.getItem("id");
  const userType = localStorage.getItem("type");

  useEffect(() => {
    if (isAuth) {
      dispatch({ type: SET_USER, payload: { _id: userId, type: userType } });
    }
  }, [isAuth, userId, userType]);

  return (
    <Suspense fallback={"Loading"}>
      <BrowserRouter>
        <Switch>
          <Route exact path="/" component={Home} />
          {isAuth && userType === "interviewee" && (
            <>
              <Route exact path="/schedule" component={Schedule} />
              <Route exact path="/payment" component={Payment} />
              <Route path="/profile" component={ProfileInterview} />
            </>
          )}
          {isAuth && userType === "interviewer" && (
            <>
              <Route exact path="/avaiability" component={UpdateAvailability} />
              <Route path="/profile" component={ProfileInterview} />
            </>
          )}
        </Switch>
      </BrowserRouter>
    </Suspense>
  );
}

export default App;
